<template>
    <b-tr>
        <b-td class="text-center">{{ index + 1 }}</b-td>
        <b-td class="text-center">
            <b-form-checkbox v-model="item.selected" @change="onSelectionChange"></b-form-checkbox>
        </b-td>
        <b-td>{{ item.cons_no }}</b-td>
        <b-td>{{ item.cons_name || '-' }}</b-td>
        <b-td class="text-right">₹ {{ formattedBalance }}</b-td>
        <b-td>
            <b-form-input
                type="number"
                min="1"
                size="sm"
                :disabled="!item.selected"
                v-model.number="item.amount"
                :state="amountState"
                placeholder="Enter amount">
            </b-form-input>
        </b-td>
    </b-tr>
</template>

<script>
export default {
    name: 'PaymentConsumerRow',
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        formattedBalance() {
            const num = Number(this.item.balance);
            return Number.isFinite(num) ? num.toFixed(2) : '0.00';
        },
        amountState() {
            if (!this.item.selected) return null;
            return Number(this.item.amount) > 0 ? null : false;
        }
    },
    methods: {
        onSelectionChange() {
            if (!this.item.selected) {
                this.item.amount = null;
            }
        }
    }
}
</script>